<div class="summary-content" id="DashBoradSummary" [ngClass]="{'showSummaryContent': showSummary}">
  <button (click)="toggleSummary()" class="btn btn-sm summaryBtn">
    <i class="fa fa-caret-right"></i>
  </button>
  <div class="filter">
    <h5 class="{{selectedLanguage}}" title="{{'Summary' | translate}}">{{'Summary' | translate}}</h5>
    <div class="time">
      <p-selectButton [options]="summaryRangeOptions" [(ngModel)]="summarySelectedRangeOptions" (onChange)="selectedTimeRange($event)" [allowEmpty]="false"></p-selectButton>
    </div>
  </div>
  <div class="range">
    <small *ngIf="last7daysflag"><span *ngIf="preferenceService.dateFormat ==='MM/dd/yyyy' || preferenceService.dateFormat ==='dd/MM/yyyy' else last7TimeDateFormat">{{last7Time}}</span> - {{endTime}} <span>(UTC {{timezone}})</span></small>
    <small *ngIf="last30daysflag"><span *ngIf="preferenceService.dateFormat ==='MM/dd/yyyy' || preferenceService.dateFormat ==='dd/MM/yyyy' else last30TimeDateFormat">{{last30Time }}</span> - {{endTime}} <span>(UTC {{timezone}})</span></small>
    <ng-template #last7TimeDateFormat>
      <span>{{last7Time}}</span>
    </ng-template>
    <ng-template #last30TimeDateFormat>
      <span>{{last30Time}}</span>
    </ng-template>
  </div>
  <p-scrollPanel [style]="{width: '100%', height: scrollPanelHeight + 'px'}">
    <div class="row summary-row" *ngIf="!alertweeklySummary && alertmonthlySummary">
      <div class="col-md-12" [ngClass]="{'border-none': i == 2}" *ngFor="let item of summaryWeeklyDataList; let i=index;">
        <div class="summary">
          <div class="summary-data" *ngIf="item.title !== 'Number of Device'">
            <p>
              <span>{{item.title | translate}}</span>
              <a role="button" tabindex="0" style="cursor: pointer;" (click)="showSummaryDetail(item); $event.preventDefault()" *ngIf="item.number > 0"><span class="badge bg-light rounded-pill">
                  <i class="fa fa-angle-right" aria-hidden="true"></i></span>
              </a>
            </p>
            <h4 [ngStyle]="{'color': item.color}">{{item.number}}</h4>
          </div>
          <div class="chart" *ngIf="i >=2 && i == 2">
            <div class="chartEmpty" *ngIf="chartWeeklyDonutEmpty">
              <span class="fa fa-circle-o"></span>
              <small class="text" translate>No Data found</small>
            </div>
            <apx-chart [series]="chartWeeklyDonutOptions.series" [chart]="chartWeeklyDonutOptions.chart" [labels]="chartWeeklyDonutOptions.labels" [dataLabels]="chartWeeklyDonutOptions.dataLabels"
                       [colors]="chartWeeklyDonutOptions.colors" [stroke]="chartWeeklyDonutOptions.stroke" [legend]="chartWeeklyDonutOptions.legend"></apx-chart>
          </div>
          <div class="chart" *ngIf="i <= 2 && item.number > 0">
            <div *ngIf="item.title === 'Warning Event'">
              <apx-chart [series]="warningChartWeeklyOptions.series" [chart]="warningChartWeeklyOptions.chart" [xaxis]="warningChartWeeklyOptions.xaxis" [dataLabels]="warningChartWeeklyOptions.dataLabels" [grid]="warningChartWeeklyOptions.grid"
                         [stroke]="warningChartWeeklyOptions.stroke" [title]="warningChartWeeklyOptions.title" [colors]="warningWeeklyOptions.colors" [tooltip]="warningChartWeeklyOptions.tooltip" [yaxis]="warningChartWeeklyOptions.yaxis"></apx-chart>
            </div>
            <div *ngIf="item.title === 'Critical Event'">
              <apx-chart [series]="criticalChartWeeklyOptions.series" [chart]="criticalChartWeeklyOptions.chart" [xaxis]="criticalChartWeeklyOptions.xaxis" [dataLabels]="criticalChartWeeklyOptions.dataLabels" [grid]="criticalChartWeeklyOptions.grid"
                         [stroke]="criticalChartWeeklyOptions.stroke" [title]="criticalChartWeeklyOptions.title" [colors]="criticalWeeklyOptions.colors" [tooltip]="criticalChartWeeklyOptions.tooltip" [yaxis]="criticalChartWeeklyOptions.yaxis"></apx-chart>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row summary-row" *ngIf="alertweeklySummary && !alertmonthlySummary">
      <div class="col-md-12" [ngClass]="{'border-none': i == 2}" *ngFor="let item of summaryMonthlyDataList; let i=index;">
        <div class="summary">
          <div class="summary-data" *ngIf="item.title !== 'Number of Device'">
            <p>
              <span>{{item.title | translate}}</span>
              <a role="button" tabindex="0" style="cursor: pointer;" (click)="showSummaryDetail(item); $event.preventDefault()" *ngIf="item.number > 0"><span class="badge bg-light rounded-pill">
                  <i class="fa fa-angle-right" aria-hidden="true"></i></span>
              </a>
            </p>
            <h4 [ngStyle]="{'color': item.color}">{{item.number}}</h4>
          </div>
          <div class="chart" *ngIf="i >=2 && i == 2">
            <div class="chartEmpty" *ngIf="chartMonthlyDonutEmpty">
              <span class="fa fa-circle-o"></span>
              <small class="text" translate>No Data found</small>
            </div>
            <apx-chart [series]="chartMonthlyDonutOptions.series" [chart]="chartMonthlyDonutOptions.chart" [labels]="chartMonthlyDonutOptions.labels" [dataLabels]="chartMonthlyDonutOptions.dataLabels"
                       [colors]="chartMonthlyDonutOptions.colors" [stroke]="chartMonthlyDonutOptions.stroke" [legend]="chartMonthlyDonutOptions.legend"></apx-chart>
          </div>
          <div class="chart" *ngIf="i <= 2 && item.number > 0">
            <div *ngIf="item.title === 'Warning Event'">
              <apx-chart [series]="warningChartMonthlyOptions.series" [chart]="warningChartMonthlyOptions.chart" [xaxis]="warningChartMonthlyOptions.xaxis" [dataLabels]="warningChartMonthlyOptions.dataLabels" [grid]="warningChartMonthlyOptions.grid"
                         [stroke]="warningChartMonthlyOptions.stroke" [title]="warningChartMonthlyOptions.title" [colors]="warningMonthlyOptions.colors" [tooltip]="warningChartMonthlyOptions.tooltip" [yaxis]="warningChartMonthlyOptions.yaxis"></apx-chart>
            </div>
            <div *ngIf="item.title === 'Critical Event'">
              <apx-chart [series]="criticalChartMonthlyOptions.series" [chart]="criticalChartMonthlyOptions.chart" [xaxis]="criticalChartMonthlyOptions.xaxis" [dataLabels]="criticalChartMonthlyOptions.dataLabels" [grid]="criticalChartMonthlyOptions.grid"
                         [stroke]="criticalChartMonthlyOptions.stroke" [title]="criticalChartMonthlyOptions.title" [colors]="criticalMonthlyOptions.colors" [tooltip]="criticalChartMonthlyOptions.tooltip" [yaxis]="criticalChartMonthlyOptions.yaxis"></apx-chart>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="alert alert-secondary center" *ngIf="alertweeklySummary && alertmonthlySummary">
      <p>Event Summary Detail is only availabe for Level 2 users (and above)</p>
      <button type="button" pButton (click)="purchaseRouter()" label="{{'Upgrade Now' | translate}}" class="{{Confirm_button}}"></button>
    </div> -->
  </p-scrollPanel>
  <!-- <p-scrollPanel [style]="{width: '100%', height: scrollPanelHeight + 'px'}">

  </p-scrollPanel> -->
</div>
<!-- <ng-template>
  <div class="dialog-content device-list">
    <div class="list-group">
      <a [routerLink]="item.routeLink" class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
         *ngFor="let item of summaryListData; let i=index;">
        {{item.title}}
        <span class="badge bg-light rounded-pill">
          <i class="fa fa-angle-right" aria-hidden="true"></i>
        </span>
      </a>
    </div>
  </div>
</ng-template> -->

<p-dialog header="{{'Attention' | translate}}" [(visible)]="displayConfirmDialog" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-exclamation-circle warning"></i>
    </div>
    <div class="content-info">
      <p translate>Event Summary Detail is only available for Level 20N users (and above)</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton (click)="purchaseRouter()" label="{{'Upgrade Now' | translate}}" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>
